<template>
  <div class="flex items-center sm:space-x-4">
    <div class="hidden items-center space-x-2 text-xs font-bold text-supplement lg:flex">
      <span>{{ $t('share') }}</span>
      <Icon
        icon="long-arrow-right"
        class="text-sm text-gray-300"
      />
    </div>

    <div class="space-y-3 text-sm lg:flex lg:space-x-2 lg:space-y-0">
      <div
        class="flex items-center space-x-4"
        @click="openShareModal('facebook')"
      >
        <Button
          icon="facebook"
          icon-prefix="fab"
          :ui="{ base: 'h-10 w-10 p-0 bg-blue-100 text-blue-500 hover:bg-blue-500 shadow-none' }"
        />
        <span class="text-primary hover:text-primary-hover lg:hidden">{{ $t('share_on_facebook') }}</span>
      </div>

      <div
        class="flex items-center space-x-4"
        @click="openShareModal('instagram')"
      >
        <Button
          icon="instagram"
          icon-prefix="fab"
          :ui="{ base: 'h-10 w-10 p-0 bg-pink-100 text-pink-500 hover:bg-pink-500 shadow-none' }"
        />
        <span class="text-primary hover:text-primary-hover lg:hidden">{{ $t('share_on_instagram') }}</span>
      </div>

      <div
        class="flex items-center space-x-4"
        @click="openShareModal('linkedin')"
      >
        <Button
          icon="linkedin"
          icon-prefix="fab"
          :ui="{ base: 'h-10 w-10 p-0 bg-[#dcedfd] text-[#0a66c2] hover:bg-[#0a66c2] shadow-none' }"
        />
        <span class="text-primary hover:text-primary-hover lg:hidden">{{ $t('share_on_linkedin') }}</span>
      </div>

      <div
        class="flex items-center space-x-4"
        @click="openShareModal('whatsapp')"
      >
        <Button
          icon="whatsapp"
          icon-prefix="fab"
          :ui="{ base: 'h-10 w-10 p-0 bg-[#b1f1c9] text-[#1b994a] hover:bg-[#25d366] hover:text-white shadow-none' }"
        />
        <span class="text-primary hover:text-primary-hover lg:hidden">{{ $t('share_on_whatsapp') }}</span>
      </div>

      <div
        class="flex items-center space-x-4"
        @click="openShareModal('email')"
      >
        <Button
          icon="envelope"
          icon-prefix="fas"
          :ui="{ base: 'h-10 w-10 p-0 bg-purple-100 text-purple-500 hover:bg-purple-500 shadow-none' }"
        />
        <span class="text-primary hover:text-primary-hover lg:hidden">{{ $t('share_by_email') }}</span>
      </div>

      <div
        class="flex items-center space-x-4"
        @click="openShareModal('qrcode')"
      >
        <Button
          icon="qrcode"
          icon-prefix="fas"
          :ui="{ base: 'h-10 w-10 p-0 bg-teal-100 text-teal-500 hover:bg-teal-500 shadow-none' }"
        />
        <span class="text-primary hover:text-primary-hover lg:hidden">{{ $t('get_qr_code') }}</span>
      </div>

      <div
        class="flex items-center space-x-4"
        @click="openShareModal('link')"
      >
        <Button
          icon="link"
          icon-prefix="fas"
          :ui="{ base: 'h-10 w-10 p-0 bg-amber-100 text-amber-500 hover:bg-amber-500 shadow-none' }"
        />
        <span class="text-primary hover:text-primary-hover lg:hidden">{{ $t('get_link') }}</span>
      </div>

      <Admin>
        <div
          class="flex items-center space-x-4"
          @click="openShareModal('embed')"
        >
          <Button
            icon="code"
            icon-prefix="fas"
            :ui="{ base: 'h-10 w-10 p-0 bg-pink-100 text-pink-500 hover:bg-pink-500 shadow-none' }"
          />
          <span class="text-primary hover:text-primary-hover lg:hidden">{{ $t('get_embed_code') }}</span>
        </div>
      </Admin>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { LandingPage } from '~/types/landing-page'
import type { ShareOption } from '~/types/partner'

const props = withDefaults(
  defineProps<{
    label?: string
    collectionName: string
    landingPageUrl: string
    embedCode: string
    partnerName: string
    socialShareText: string | null
    media?: LandingPage['media'] | null
  }>(),
  {
    label: 'Share content'
  }
)

// Share Modal
const { openModal } = useModal()
const ShareModal = resolveComponent('LazyShareModal')

const openShareModal = (activeOption: ShareOption) =>
  openModal(ShareModal, {
    landingPageUrl: props.landingPageUrl,
    partnerName: props.partnerName,
    embedCode: props.embedCode,
    socialShareText: props.socialShareText,
    media: props.media,
    activeOption
  })
</script>
